import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Search = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M31.666 30.268a17.922 17.922 0 0 0 4.418-11.808C36.084 8.516 27.99.42 18.05.42S0 8.516 0 18.46C0 28.404 8.093 36.5 18.033 36.5c4.383 0 8.525-1.57 11.804-4.42l11.958 11.964c.26.26.587.38.915.38.328 0 .656-.12.915-.38.5-.5.5-1.329 0-1.83l-11.96-11.946ZM2.588 18.46c0-8.528 6.938-15.45 15.445-15.45 8.508 0 15.445 6.94 15.445 15.45a15.36 15.36 0 0 1-4.521 10.928 15.347 15.347 0 0 1-10.924 4.523c-8.507.017-15.445-6.923-15.445-15.45Z"
  }));
});
Search.displayName = 'Search';
Search.defaultProps = {
  'aria-label': 'Search'
};
export default Search;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/Search.js
// module id = 3274
// module chunks = 11